import UserSurvey from './pages/user_survey/UserSurvey'
import Interview from './pages/interview/Interview'
import History from './pages/history/History'
import Feedback from './pages/feedback/Feedback'
import Dashboard from './pages/dashboard/Dashboard'
import Pricing from './pages/pricing/Pricing'
import TopInterview from './pages/top_interview/TopInterview'
import InterviewDetail from './pages/top_interview/InterviewDetail'
import QuestionBank from './pages/question_bank/QuestionBank'
import EnhancedQuestionBank from './pages/enhanced_question_bank/EnhancedQuestionBank'
import QuestionBankFeedback from './pages/question_bank_feedback/QuestionBankFeedback'
import ThankYou from './pages/thank_you/ThankYou'

import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';

export default function Router() {
    const Layout = () => {
        return (
            <>
            <div className="content"><Outlet /></div>
            </>
        )
    }

    return (
        <BrowserRouter>
            <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/pricing" replace />} />
                <Route path="/interview" element={<Interview />} />
                <Route path="/home" element={<Dashboard />} />
                <Route path="/survey" element={<UserSurvey />} />
                <Route path="/history" element={<History />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/topInterview" element={<TopInterview />} />
                <Route path="/topInterview/:slug" element={<InterviewDetail />} />
                <Route path="/questionBank" element={<QuestionBank />} />
                <Route path="/enhanced-question-bank" element={<EnhancedQuestionBank />} />
                <Route path="/question-bank-feedback" element={<QuestionBankFeedback />} />
                <Route path="/thank-you" element={<ThankYou />} />
            </Route>
            </Routes>
        </BrowserRouter>
    )
}